export const GET_FIELD_TASK_COMPLETE_COUNT = 'GET_FIELD_TASK_COMPLETE_COUNT';
export const FIELD_TASK_COMPLETE_RESPONSE = 'FIELD_TASK_COMPLETE_RESPONSE';